import { crudService } from '../_services'

export const totvsProdutoAction = {
  getTotvsProdutoSelect,
  getTotvsProdutoByLojaSelect,
  changeDetailsProduto,
  onChangeDetailsProduto,
  onChangeProps,
  editProdutosDetails,
  clear,
  clearAll
}

let filterModel = {
  Page: 1,
  Limit: 10,
  Term: ''
};

function getTotvsProdutoSelect() {
  return (dispatch) => {
    let apiEndpoint = 'totvsProdutos/select';
    crudService
      .get(apiEndpoint)
      .then((response) => {
        dispatch(changeProdutosList(response.data, 0))
      })
      .catch((err) => {
        console.log(err.response);
        return err.response;
      })
  }
}

function getTotvsProdutoByLojaSelect(id) {
  return (dispatch) => {
    let apiEndpoint = 'totvsProdutos/select/loja/' + id;
    crudService
      .get(apiEndpoint)
      .then((response) => {
        console.log('response.data', response.data)
        dispatch(changeProdutosListSelect(response.data, 0))
      })
      .catch((err) => {
        console.log(err.response);
        return err.response;
      })
  }
}
function onChangeProps(props, event) {
  return (dispatch) => {
    if (event.target.type === 'checkbox') {
      dispatch(handleOnChangeProps(props, event.target.checked))
    } else {
      dispatch(handleOnChangeProps(props, event.target.value))
    }
  }
}

function changeDetailsProduto(totvsProduto) {
  return (dispatch) => {
    if (totvsProduto) {
      dispatch(onChangeDetailsProduto(totvsProduto))
    } else {
      clear()
    }
  }
}

export function onChangeDetailsProduto(totvsProduto) {
  return [
    {
      type: 'CHANGE_DETAILS_TOTVS_PRODUTO',
      id: totvsProduto.id,
      nome: totvsProduto.nome,
      descricao: totvsProduto.descricao,
    }
  ]
}


export function addProduto(payload) {
  return [{ type: 'ADD_TOTVS_PRODUTO', totvsProduto: payload }, clear()]
}

export function changeProdutosList(totvsProduto, totalRows) {
  return {
    type: 'FETCHED_ALL_TOTVS_PRODUTO',
    totvsProduto: totvsProduto,
    totalRegistros: totalRows
  }
}

export function changeProdutosListSelect(totvsProduto, totalRows) {
  return {
    type: 'FETCHED_ALL_TOTVS_PRODUTO',
    totvsProduto: totvsProduto,
    totalRegistros: totalRows
  }
}

export function clear() {
  return {
    type: 'TOTVS_PRODUTO_CLEAR'
  }
}

export function clearAll() {
  return {
    type: 'TOTVS_PRODUTO_CLEAR_ALL'
  }
}

export function handleOnChangeProps(props, value) {
  return {
    type: 'TOTVS_PRODUTO_HANDLE_ON_CHANGE',
    props: props,
    value: value
  }
}

export function editProdutosDetails(totvsProduto) {
  return {
    type: 'TOTVS_PRODUTO_DETAIL',
    id: totvsProduto.id,
    codigo: totvsProduto.codigo,
    descricao: totvsProduto.descricao,
    idLoja: totvsProduto.idLoja
  }
}

export function updatedProdutoInfo() {
  return {
    type: 'TOTVS_PRODUTO_UPDATED'
  }
}

export function createProdutoInfo() {
  return {
    type: 'TOTVS_PRODUTO_CREATE D_SUCCESSFULLY'
  }
}

export function deleteProdutosDetails() {
  return {
    type: 'DELETED_TOTVS_PRODUTO_DETAILS'
  }
}
export function isLoading() {
  return {
    type: 'TOTVS_PRODUTO_ISLOADING'
  }
}

export function notIsLoading() {
  return {
    type: 'TOTVS_PRODUTO_NOTISLOADING'
  }
}
